﻿declare const window: {
	__ENV: Environment
} & Window;

export interface Environment {
	REACT_APP_API_HOST: string;
	REACT_APP_HOSTNAME: string;
}

const REACT_APP_API_HOST: string = window.__ENV?.REACT_APP_API_HOST || `${window.location.origin}/api`;
const REACT_APP_HOSTNAME: string = window.__ENV?.REACT_APP_HOSTNAME || window.location.hostname;

export {
	REACT_APP_API_HOST,
	REACT_APP_HOSTNAME
};
